<template>
  <div class="listContainer">
    <section class="content">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="合同名称" prop="agreement_name">
          <a-input v-model="form.agreement_name" />
        </a-form-model-item>
        <a-form-model-item label="公司(甲方)名称" prop="platform_name">
          <a-input v-model="form.platform_name" />
        </a-form-model-item>
        <a-form-model-item label="公司地址">
          <a-input v-model="form.platform_address" />
        </a-form-model-item>
        <a-form-model-item label="是否需要签署" prop="status">
          <a-radio-group v-model="form.status">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="2">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="状态类型" prop="type">
          <a-radio-group v-model="form.type">
            <a-radio :value="1">入职合同</a-radio>
            <a-radio :value="2">离职合同</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="工作类型" prop="work_contract_type">
          <a-radio-group v-model="form.work_contract_type">
            <a-radio :value="1">长期工合同</a-radio>
            <a-radio :value="2">临时工合同</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="是否提供员工下载" prop="is_guard_download">
          <a-radio-group v-model="form.is_guard_download">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="2">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="*合同PDF">
          <input
            type="file"
            placeholder="请上传PDF格式"
            accept="application/pdf"
            @change="handleChange"
          />
        </a-form-model-item>
        <a-form-model-item
          class="onSubmitStyle"
          :wrapper-col="{ span: 12, offset: 8 }"
        >
          <a-button @click="resetForm">重置</a-button>
          <a-button type="primary" @click="onSubmit">提交</a-button>
        </a-form-model-item>
      </a-form-model>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import * as qiniu from "qiniu-js";
export default {
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 8 },
      form: {
        agreement_name: "",
        platform_name: "",
        platform_address: "",
        business_file_key: "",
        status: "",
        type: "",
        work_contract_type: "",
        is_guard_download: ""
      },
      headers: {
        authorization: "authorization-text"
      },
      rules: {
        status: [
          {
            required: true,
            message: "请选择是否需要签署",
            trigger: "change"
          }
        ],
        agreement_name: [
          {
            required: true,
            message: "请输入合同名称",
            trigger: "blur"
          }
        ],
        platform_name: [
          {
            required: true,
            message: "请输入公司(甲方)名称",
            trigger: "blur"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择状态类型",
            trigger: "change"
          }
        ],
        work_contract_type: [
          {
            required: true,
            message: "请选择工作类型",
            trigger: "change"
          }
        ],
        is_guard_download: [
          {
            required: true,
            message: "请选择是否提供管家下载",
            trigger: "change"
          }
        ]
      }
    };
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.editDetail != undefined) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.form = {
        agreement_name: this.editDetail.agreement_name,
        platform_name: this.editDetail.platform_name,
        platform_address: this.editDetail.platform_address,
        business_file_key: this.editDetail.business_file_key,
        status: this.editDetail.status,
        type: this.editDetail.type,
        work_contract_type: this.editDetail.work_contract_type,
        is_guard_download: this.editDetail.is_guard_download
      };
    },
    handleChange(e) {
      let self = this;
      let url = this.httpsBasic.url + "cloud/Qiniu/getToken";
      axios
        .post(url, {
          count: 1
          // business_file_key_count: 3
        })
        .then(res => {
          this.form.business_file_key = res.data.data.business_file_key;
          var config = {
            useCdnDomain: true,
            region: qiniu.region.z0
          };
          var putExtra = {
            fname: "",
            params: {},
            mimeType: null
          };
          var observable = qiniu.upload(
            e.target.files[0],
            res.data.data.keys[0],
            res.data.data.token,
            putExtra,
            config
          );
          var observer = {
            next(res) {
              console.log("上传中...");
            },
            error(err) {
              // console.log(err)
              self.$alert("错误码：" + err.code + "！请重新选择图片", "提示", {
                okLabel: "知道了"
              });
            },
            complete(res) {
              console.log(res);
            }
          };
          var subscription = observable.subscribe(observer); // 上传开始
          // subscription.unsubscribe(); // 上传取消
          // console.log(this.getToken);
        });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    validation() {
      let fls = true;
      if (this.form.business_file_key == "") {
        fls = false;
        this.$message.warning("请上传合同PDF");
      }
      return fls;
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        let fls = this.validation();
        if (valid && fls) {
          let url =
            this.httpsBasic.url + this.httpsBasic.user + "Sign/editSignInfo";
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            id: this.editDetail.id,
            agreement_name: this.form.agreement_name,
            platform_name: this.form.platform_name,
            platform_address: this.form.platform_address,
            business_file_key: this.form.business_file_key,
            status: this.form.status,
            type: this.form.type,
            work_contract_type: this.form.work_contract_type,
            is_guard_download: this.form.is_guard_download
          };
          // console.log(params);
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("提交成功");
              this.resetForm();
              this.$emit("hideIsEdit", true);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.content {
  h2 {
    font-size: 16px;
    font-weight: normal;
    margin: 30px 0 30px 100px;
  }
  .onSubmitStyle {
    button {
      margin-right: 20px;
    }
  }
}
</style>
